export const isValidUrl = url => {
  return new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i').test(url);
};

export const findEmpFromHash = (hash, Employees) => {
  const name = hash.substr(1);
  const index = Employees.map(emp => {
    return toLowerJoinHyphen([emp['First Name'], emp['Last Name']]);
  }).indexOf(name);
  const result = Employees[index];

  return {
    result,
    index
  };
};

export const buildImageFileName = (firstName, lastName, size) => {
  return toLowerJoinHyphen([firstName, lastName, size]);
};

const toLowerJoinHyphen = array => {
  return array
    .join(' ')
    .toLowerCase()
    .replace(/[^a-za-z]+/g, '-');
};

export function nl2br(str){
  return str.split('\n')
      .reduce((a, c) => {
        if(a === null)
          return [c];
        a.push('<br/>');
        a.push(c);
        return a;
      }, null);
};

export const hasBio = bio => {
    return (bio.length === 1 && bio[0] !== '') || bio.length > 1;
};